// extracted by mini-css-extract-plugin
export var aiButtonContainer = "_bg-0";
export var orangeButton = "_bg-1";